import React, { Component } from 'react'

//Bootstrap
import { Container, Row, Col} from 'reactstrap';

//style
import './Information.scss'

class Information extends Component {
  constructor(props){
    super(props);
    this.state={
      LinkBrocure:"//e.issuu.com/embed.html#34872329/64968345"
    }
  }
  render(){
    return (
      <div className="sectionInformation" >
        <Container>
          <Row>
            <Col xs="12">
              <h1 className="App-intro">
                Catalogo de productos, <strong>Portaprent</strong>
              </h1>
            </Col>
            <Col xs="12" className="Informarion-brochure">
              <iframe src={this.state.LinkBrocure} className="Brochure" title="brochure"></iframe>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}
export default Information;



// WEBPACK FOOTER //
// ./src/Components/Information/Information.jsx